import { PlayerColor } from '@colonist/game-states';
export const createGameGeneralSlice = ({ initialMyColor, initialTimeLeftInSeconds })=>(set)=>({
            myColor: initialMyColor,
            isMyColorSpectator: initialMyColor === PlayerColor.None,
            timeLeftInSeconds: initialTimeLeftInSeconds,
            setTimeLeftInSeconds: (timeLeftInSeconds)=>{
                set({
                    timeLeftInSeconds: timeLeftInSeconds
                });
            },
            hasUsedDisableKarmaRequest: false,
            setHasUsedDisableKarmaRequest: (hasUsed)=>{
                set({
                    hasUsedDisableKarmaRequest: hasUsed
                });
            }
        });
